import { Table } from './styles';

export const TableTip = () => {
  return (
    <Table cellPadding="2rem">
      <thead>
        <tr>
          <th className="border pOne" align="center">
            Valor
          </th>
          <th className="border" align="center">
            Grau do Dano
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="bold border" align="center">
            0
          </td>
          <td className="border pTwo">
            A infração não ocasiona danos ou somente ocasiona danos com impactos insignificantes aos
            titulares, que decorrem de situações previsíveis ou corriqueiras e que não justificam a
            necessidade de compensação.
          </td>
        </tr>
        <tr>
          <td className="bold border" align="center">
            1
          </td>
          <td className="border pTwo">
            A infração ocasiona lesão ou ofensa a direitos ou interesses de um número reduzido de
            titulares, com impacto de ordem material ou moral limitado, que pode ser revertido ou
            compensado com relativa facilidade; ou <br /> <br /> Descumprimento de determinação ou
            envio ou disponibilização de informações fora dos prazos ou condições estabelecidos pela
            ANPD, sem prejuízo direto para o processo de fiscalização ou administrativo sancionador
            ou para terceiros e que não decorra de litigância de má-fé.
          </td>
        </tr>
        <tr>
          <td className="bold border" align="center">
            2
          </td>
          <td className="border pTwo">
            A infração ocasiona lesão ou ofensa a direitos ou interesses difusos, coletivos ou
            individuais, que, dadas as circunstâncias do caso, geram impactos aos titulares, de
            ordem material ou moral, que não se enquadram nos critérios indicados na descrição do
            grau de dano 0, 1 ou 3; ou <br /> <br />
            Dano decorrente do envio de informações intempestivas ou cumprimento intempestivo com
            prejuízo direto para o processo de fiscalização ou administrativo sancionador ou para
            terceiros e que não decorra de litigância de má-fé.
          </td>
        </tr>
        <tr>
          <td className="bold border" align="center">
            3
          </td>
          <td className="border pTwo">
            A infração ocasiona lesão ou ofensa a direitos ou interesses difusos, coletivos ou
            individuais, que, dadas as circunstâncias extraordinárias do caso, têm impacto
            irreversível ou de difícil reversão sobre os titulares afetados, de ordem material
            moral, ocasionando, entre outras situações, discriminação, violação à integridade
            física, ao direito à imagem e à reputação, fraudes financeiras ou uso indevido de
            identidade; ou <br /> <br /> Danos decorrentes de litigância de má-fé, tais como, entre
            outras hipóteses previstas na legislação processual, alteração da verdade dos fatos, uso
            do processo para conseguir objetivo ilegal, resistência injustificada ao andamento do
            processo, atuação temerária em qualquer ato do processo ou impedimento da atuação da
            ANPD.
          </td>
        </tr>
      </tbody>
    </Table>
  );
};
